import { useState, useEffect, useMemo } from 'react';
import { useAuth } from '../Auth';
import { db } from '../../firebase/firebaseConfig';
import { ref, onValue, off } from 'firebase/database';

export const useEssentials = () => {
    const [ essentials, setEssentials ] = useState(null);
    const [ loading, setLoading ] = useState(true);
    const { userObj } = useAuth();
    
    useEffect(() => {
        if (!userObj) return;

        const dbRef = ref(db, 'top_essentials');
        const fetchEssentials = () => {
            setLoading(true);
            try {
                onValue(dbRef, (snapshot) => {
                    if (snapshot.exists()) {
                        const data = snapshot.val();
                        setEssentials(data);
                    }
                    setLoading(false);
                }, (err) => {
                    console.error(err);
                    setLoading(false);
                });
            } catch (err) {
                console.error(err);
                setLoading(false);
            }
        }

        fetchEssentials();

        return () => off(dbRef, 'value');

    }, [userObj]);

    return useMemo(() => ({essentials, loading}), [essentials, loading]);
};